import { CloseOutlined } from '@ant-design/icons';
import InquiryServices from '@root/modules/Sellers/Inquiry/services/inquiry';
import { Button, Form, message, Spin, Upload, UploadProps } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { UploadFile } from 'antd/lib/upload/interface';
import { useState } from 'react';

interface Props {
  productId: number;
  onSubmitted: () => void;
  statusSeller?: string;
}

const CommentAddCmt = ({ productId, onSubmitted, statusSeller }: Props) => {
  const [selectedFile, setSelectedFile] = useState([] as any);
  const [fileIdArrNew, setfileIdArrNew] = useState([] as any);
  const [fileList, setFileList] = useState<UploadFile[] | any>([]);
  const [loading, setLoading] = useState(false);

  const handleUploadFiles = (files: any) => {
    const uploaded = [...selectedFile];

    files.some((file: any) => {
      if (uploaded.findIndex((f) => f.name === file.name) === -1) {
        uploaded.push(file);
      }
      setSelectedFile(uploaded);
    });
  };

  const handleFileEvent = (e: any) => {
    const chosenFiles = Array.prototype.slice.call(e);
    handleUploadFiles(chosenFiles);
  };

  const handleAddComment = async (values: any) => {
    try {
      if (!values.comment && statusSeller !== 'SellerApproved') {
        message.error('Please input comment');
      } else if (!values.comment && fileList.length === 0) {
      } else {
        setLoading(true);
        const formData = new FormData();

        for (let i = 0; i < fileList.length; i++) {
          formData.append('files', fileList[i].originFileObj);
        }
        const uploadData = await InquiryServices.upLoad(formData);
        for (let i = 0; i < uploadData.data.paths.length; i++) {
          fileIdArrNew.push(uploadData.data.paths[i].id);
        }
        const body = {
          comment: values.comment ?? '',
          quotationId: productId,
          owner: 'Seller',
          documents: fileIdArrNew
        };
        const createCmt = await InquiryServices.createComment(body);
        setLoading(false);
        if (createCmt.message === 'success') {
          message.success('Add comment success!');
          onSubmitted();
        }
      }
    } catch (error) {
      // message.error("Can't add comment");
    }
  };

  const removeItemIndex = (index: number) => {
    setFileList([
      ...fileList.filter(
        (selected: any) => fileList.indexOf(selected) !== index
      )
    ]);
  };

  const validateFileType = (
    { type }: UploadFile,
    allowedTypes: string[] = ['image/jpeg', 'image/png']
  ) => {
    return allowedTypes.includes(type!);
  };

  const props: UploadProps = {
    onChange({ fileList: newFileList }) {
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const isAllowedType = validateFileType(file);
      if (!isAllowedType) {
        message.error(`${file.name} is not JPEG file`);
        return false;
      }
      setFileList((prev: any) => {
        if (prev.length < 4) {
          return [...prev, file];
        }

        return prev;
      });
      setFileList([...fileList, file]);
      return false;
    }
  };

  const handleAdd = (values: any) => {};

  return (
    <Spin spinning={loading}>
      <Form
        name="basic"
        initialValues={{ remember: true }}
        onFinish={handleAddComment}
        autoComplete="off"
      >
        <div style={{ display: 'flex', gap: '10px' }}>
          <div className="attachUp" style={{ marginBottom: '10px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <>
                <p style={{ marginBottom: '0px' }}>Seller's attachment</p>
              </>

              <Upload
                {...props}
                multiple
                fileList={fileList}
                accept=".png, .jpg, .jpeg"
                maxCount={4}
                showUploadList={false}
              >
                <Button
                  style={{
                    background: '#3c3d5f',
                    border: 'none',
                    color: 'white',
                    borderRadius: '8px'
                  }}
                  // disabled={statusSeller === 'SellerApproved' ?? true}
                >
                  Upload
                </Button>
              </Upload>
            </div>
            <div
              className="scrollImg"
              style={{
                height: '85px',
                overflowY: 'scroll',
                overflowX: 'scroll',
                width: '320px'
              }}
            >
              {fileList.map((item: any, index: number) => (
                <li key={index}>
                  {item.name}
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => removeItemIndex(index)}
                  >
                    <CloseOutlined />
                  </span>
                </li>
              ))}
            </div>
          </div>

          <Form.Item
            name="comment"
            rules={[
              {
                required: statusSeller === 'SellerApproved' ? false : true,
                message:
                  statusSeller === 'SellerApproved'
                    ? ' '
                    : 'Comment can not be empty'
              },
              {
                // max: 150,
                // message: 'Character must be less than 150!'
              }
            ]}
            style={{ width: '100%' }}
          >
            <div className="commentCard" style={{ marginBottom: '10px' }}>
              <div
                className="wrapTitle"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <p>Seller comment</p>
              </div>
              <p className="descript" style={{ marginBottom: '0px' }}>
                <TextArea
                  disabled={statusSeller === 'SellerApproved' ? true : false}
                  maxLength={150}
                />
              </p>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'end',
                  marginTop: '10px'
                }}
              >
                <Button
                  htmlType="submit"
                  type="primary"
                  style={{
                    backgroundColor: '#2B2C51',
                    border: 'none',
                    borderRadius: '8px',
                    color: '#fff'
                  }}
                  disabled={
                    statusSeller === 'SellerApproved' && fileList.length === 0
                      ? true
                      : false
                  }
                >
                  전송
                </Button>
              </div>
            </div>
          </Form.Item>
        </div>
      </Form>
    </Spin>
  );
};

export default CommentAddCmt;
